export const LOGIN = 'login';
export const ACCOUNT = 'account';
export const SIGNUP = 'signup';
export const PREMIUM = 'premium';



// WEBPACK FOOTER //
// ./app/constants/landingPage.js